<template>
    <a-layout>
        <a-layout-sider v-if="winwidth>winwidthmodelimit&&!ismobile" v-model:collapsed="collapsed" :width="250" :trigger="null" collapsible class="sidemenucontainer">
            <fep-sidemenus :selectedkey="$uimenuselectedkey" v-model:collapsed="collapsed"/>
        </a-layout-sider>
        <a-drawer v-else width="60%" placement="left" :title="$langsmgr('langkey.sitename.short')" :open="drawstate" :closable="false" @close="closeDraw">
            <template #extra>
                <menu-fold-outlined class="trigger" @click="closeDraw"></menu-fold-outlined>
            </template>
            <fep-sidemenus :selectedkey="$uimenuselectedkey" :collapsed="true"/>
        </a-drawer>
        <a-layout-header class="headcontainer">
            <div class="headright">
                <span class="headmenu noselect">
                    <fep-headmenus/>
                </span>
            </div>
            <div v-if="winwidth>winwidthmodelimit&&!ismobile">
                <span :class="winwidth>winwidthmodelimit&&collapsed?'pcleftcollapsed':'pcleft'"></span>
                <menu-unfold-outlined v-if="collapsed" class="trigger" @click="switchmenu"></menu-unfold-outlined>
                <menu-fold-outlined v-else class="trigger" @click="switchmenu"></menu-fold-outlined>
                <span style="margin-left:10px;color:#999999" class=noselect>{{$langsmgr(currentviewlankey)}}</span>
            </div>
            <div v-else>
                <menu-unfold-outlined class="trigger" @click="switchmenu"></menu-unfold-outlined>
                <span style="margin-left:10px;color:#999999" class=noselect>{{$langsmgr(currentviewlankey)}}</span>
            </div>
        </a-layout-header>
        <a-layout-content class="acontent" :class="winwidth>winwidthmodelimit&&!ismobile?collapsed?'acontentlite':'acontentfull':null">
            <div :class="!ismobile?(winwidth>winwidthmodelimit?'vcontentlite':'vcontentfull'):'vcontentfull'">
                <a-row>
                    <a-col :span="24">
                        <div class="hayakudraw">
                            <a-skeleton active :loading="loading_announce" :style="{padding:'20px'}">
                                <a-carousel autoplay>
                                    <a v-for="ann in sysannounces" href="javascript:;" @click="showAnnounce(ann)">
                                        <div>
                                            <span class="announcetip">{{$langsmgr('langkey.component.dashboard.announce')}}</span>
                                        </div>
                                        <div class="announcetit">
                                            <span>{{ann.title}}</span>
                                        </div>
                                        <div class="announcedate">{{ann.regtime}}</div>
                                    </a>
                                </a-carousel>
                            </a-skeleton>
                        </div>

                        <a-card :title="$langsmgr('langkey.component.dashboard.mysubscribe')" :bordered="false" class="rowcard" :size="ismobile?'small':'default'"
                            :style="{borderRadius:'2px'}" :headStyle="{backgroundColor:'#f8f9fc'}">
                            <a-skeleton active :loading="loading_subscribe">
                                <div v-if="usersubscribed">
                                    <p>
                                        <h2><strong>{{userservpack.packname}}</strong></h2>
                                    </p>
                                    <p class="expiresinfo">
                                        <span>{{$langsmgr('langkey.component.dashboard.subscribe.expiresinfo',{"{0}":userservpack.expiresed,"{1}":userservpack.expiresdays})}}</span>
                                        <span v-if="userservpack.expiresed>0x1e">{{$langsmgr('langkey.component.dashboard.subscribe.resetinfo',{"{0}":userservpack.resetdays})}}</span>
                                    </p>
                                    <p class="progressline">
                                        <a-progress :percent="userflowpercent" status="active" :show-info="false" size="small"></a-progress>
                                        <strong>{{$langsmgr('langkey.component.dashboard.subscribe.flowinfo',{"{0}":userservpack.flowused,"{1}":userservpack.flowtotal})}}</strong>
                                    </p>
                                </div>
                                <div v-else>
                                    <a class="empsubscr" href="javascript:;" @click="buypackage">
                                        <div class="addsubscr"><strong><PlusOutlined/></strong></div>
                                        <div class="buysubscr">{{$langsmgr('langkey.component.dashboard.buysubscribe')}}</div>
                                    </a>
                                </div>
                            </a-skeleton>
                        </a-card>

                        <a-card :title="$langsmgr('langkey.component.dashboard.fastway')" :bordered="false" class="rowcard" :size="ismobile?'small':'default'"
                            :style="{borderRadius:'2px'}" :headStyle="{backgroundColor:'#f8f9fc'}" 
                            :bodyStyle="{backgroundColor:'white',margin:0,padding:0}">
                            <a href="javascript:;" class="infoitem" @click="viewdocument">
                                <div class="infoicon"><ReadOutlined/></div>
                                <div class="infolinetit">{{$langsmgr('langkey.component.dashboard.fastway.viewdoc')}}</div>
                                <div class="infolinedec">{{$langsmgr('langkey.component.dashboard.fastway.viewdoc.intro')}}</div>
                            </a>
                            <a-divider :style="{margin:0}"/>
                            <a href="javascript:;" class="infoitem" @click="showSubscribe">
                                <div class="infoicon"><CloudDownloadOutlined/></div>
                                <div class="infolinetit">{{$langsmgr('langkey.component.dashboard.fastway.subscribe')}}</div>
                                <div class="infolinedec">{{$langsmgr('langkey.component.dashboard.fastway.subscribe.intro')}}</div>
                            </a>
                            <a-divider :style="{margin:0}"/>
                            <a href="javascript:;" class="infoitem" @click="rechargeservpack">
                                <div class="infoicon"><HistoryOutlined/></div>
                                <div class="infolinetit">{{$langsmgr('langkey.component.dashboard.fastway.recharge')}}</div>
                                <div class="infolinedec">{{$langsmgr('langkey.component.dashboard.fastway.recharge.intro')}}</div>
                            </a>
                            <a-divider :style="{margin:0}"/>
                            <a href="javascript:;" class="infoitem" @click="gotickets">
                                <div class="infoicon"><QuestionCircleOutlined/></div>
                                <div class="infolinetit">{{$langsmgr('langkey.component.dashboard.fastway.question')}}</div>
                                <div class="infolinedec">{{$langsmgr('langkey.component.dashboard.fastway.question.intro')}}</div>
                            </a>
                        </a-card>
                    </a-col>
                </a-row>
                <Cntfooter/>
            </div>
            <div>
                <a-modal v-model:open="announceshowstate" width="700px" :footer="null" 
                    :title="$langsmgr('langkey.component.dashboard.announce')">
                    <div>
                        <h2>{{drawerAnnounceTitle}}</h2>
                    </div>
                    <div v-html="drawerAnnounceContent"></div>
                </a-modal>
                <a-modal v-model:open="subscrmodalshowstate" width="300px" :closable="false" centered :header="null" :footer="null" :style="{borderRadius:'2px'}">
                    <subscrctls @copycallback="copysubscr" @qrcodecallback="switchqrcode" 
                        @importcfwcallback="importcfw" @importshadowrocketcallback="importshadowrocket" 
                        @viewdoccallback="viewdocument" @downloadconfigcallback="downloadconfig"/>
                </a-modal>
                <a-modal v-model:open="qrcodemodalshowstate" width="300px" :closable="false" centered :header="null" :footer="null" :style="{borderRadius:'2px'}">
                    <div class="qrcodearea">
                        <vue-qr :text="userservpack.subscribeuri" :margin="0" :size="128"/>
                    </div>
                    <div class="qrcodeintro">
                        {{$langsmgr('langkey.component.dashboard.subscribe.qrcodetips')}}
                    </div>
                </a-modal>
                <a-drawer v-if="ismobile" placement="bottom" height="255px" :open="subscrdrawershowstate" :closable="false" :maskClosable="true" :title="null" @close="subscrdrawerClose">
                    <subscrctls 
                        @copycallback="copysubscr"
                        @qrcodecallback="switchqrcode" 
                        @importcfwcallback="importcfw" 
                        @importshadowrocketcallback="importshadowrocket"
                        @viewdoccallback="viewdocument" 
                        @onchangeroute="changeroute" 
                        @downloadconfigcallback="downloadconfig"/>
                </a-drawer>
            </div>
        </a-layout-content>
    </a-layout>
</template>
<script setup>
import {MenuFoldOutlined,MenuUnfoldOutlined,CaretDownOutlined,ReadOutlined,CloudDownloadOutlined,HistoryOutlined,QuestionCircleOutlined,PlusOutlined} from '@ant-design/icons-vue'
import { ref,getCurrentInstance, onMounted, onUnmounted } from 'vue'
import subscrctls from './subscrctls.vue'
import Cntfooter from './cntfooter.vue'
import axios from 'axios'
import {message} from 'ant-design-vue'
import useClipboard from 'vue-clipboard3'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'

const {toClipboard} = useClipboard()


const currentviewlankey = ref('langkey.menuitem.dashboard')
const winwidthmodelimit = 1320
const drawstate = ref(false)
const winwidth = ref(0)
const usersubscribed = ref(false)
const userservpack = ref({
    subscribeid: null,
    subscribeuri: null,
    packid: null,
    planid: null,
    packname: null,
    expiresed: null,
    expiresdays: null,
    resetdays: null,
    flowused: null,
    flowtotal: null
})
const userflowpercent = ref(0)

const loading_subscribe = ref(true)
const loading_announce = ref(true)

const btmpanelheight = ref('310px')

const ginstance = getCurrentInstance()
const gconfig = ginstance.appContext.config.globalProperties;
const collapsed = ref(ginstance.appContext.config.globalProperties.$uimenucollapsed)
const ismobile = ref(ginstance.appContext.config.globalProperties.$ismobile())
const announceshowstate = ref(false)
const subscrmodalshowstate = ref(false)
const subscrdrawershowstate = ref(false)
const subscrmodal = ref(null)
const qrcodemodalshowstate = ref(false)
const sysannounces = ref([])

const drawerAnnounceTitle = ref('')
const drawerAnnounceContent = ref('')

const whenWindowResize=()=>{ winwidth.value = window.innerWidth }
const switchmenu = () => {
    if(!ismobile.value&&winwidth.value>winwidthmodelimit) ginstance.appContext.config.globalProperties.$uimenucollapsed = collapsed.value = !collapsed.value
    else showDraw()
}
const showDraw = () => { drawstate.value = true }
const closeDraw = () => { drawstate.value = false }
const showAnnounce = (announce) => {
    drawerAnnounceTitle.value = announce.title
    drawerAnnounceContent.value = announce.content

    announceshowstate.value = true
}
const showSubscribe = () => {
    if(!ismobile.value) subscrmodalshowstate.value = true
    else {
        subscrdrawershowstate.value = true
    }
}
const subscrdrawerClose = () => {
    subscrdrawershowstate.value = false
}
const copysubscr = async() => {
    try{ 
        await toClipboard(userservpack.value.subscribeuri)
        message.success('订阅地址复制成功')
    } catch { message.error('目前没有可用的订阅，请先购买订阅') }
}

const switchqrcode = () => {
    qrcodemodalshowstate.value = true
}

const importcfw = () => {
    window.open(`clash://install-config?url=${encodeURIComponent(userservpack.value.subscribeuri)}`,'_self')
}
const importshadowrocket = () => {
    window.open(`shadowrocket://add/sub://${Base64.encode(userservpack.value.subscribeuri)}/?remark=${encodeURIComponent(gconfig.$sitename)}`,'_self')
}

const viewdocument = () => {
    ginstance.appContext.config.globalProperties.$uimenuselectedkey = '15'
    location.href="#/documents"
}
const buypackage = () => {
    ginstance.appContext.config.globalProperties.$uimenuselectedkey = "10"
    location.href="#/plans"
}
const rechargeservpack = () => {
    if(userservpack.value.packid){
        ginstance.appContext.config.globalProperties.$uimenuselectedkey = "11"
        location.href=`#/plan?p=${userservpack.value.packid}`
    }else buypackage()
}
const gotickets = () => {
    ginstance.appContext.config.globalProperties.$uimenuselectedkey = "13"
    location.href="#/tickets"
}
const downloadconfig = () => {
    var __subid = userservpack.value.subscribeid
    //console.log(userservpack.value)
    if(__subid){
        window.open(`${gconfig.$backendbase}/dashboard/v3/dlconfig?id=${__subid}${!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X.*/)?'':'&type=clash'}`,'_blank')
    }else{
        message.error('目前没有可用的订阅，请先购买订阅')
    }
}


onMounted(()=>{
    whenWindowResize()
    window.addEventListener('resize', whenWindowResize)

    axios.get(`${gconfig.$backendbase}/global/v4/fingerprint`,{
        params: {r:Math.random()}
    });

    axios.get(`${gconfig.$backendbase}/dashboard/v3/announces`,{
        headers: gconfig.$getauthheaders()
    }).then((response)=>{
        if(response.data.data.result && response.data.data.announces.length>0x00) {
            for(var i = 0x00; i < response.data.data.announces.length; i++)
                sysannounces.value.push({
                    id:response.data.data.announces[i].id,
                    title:response.data.data.announces[i].title,
                    content:decodeURIComponent(response.data.data.announces[i].content),
                    regtime:response.data.data.announces[i].regtime,
                })
        }
        loading_announce.value = false
    }).catch((error)=>{
        gconfig.$axiosErrorHandle(error)
    })

    axios.get(`${gconfig.$backendbase}/dashboard/v3/useroverview`, {
        headers: gconfig.$getauthheaders()
    }).then((response)=>{
        if(response.data.data.result) {
            usersubscribed.value = response.data.data.servpack != null
            if(usersubscribed.value) {
                gconfig.$vusubscrid = userservpack.value.subscribeid = response.data.data.subscribeid
                gconfig.$storage.set(gconfig.$storagekey_fep_vusubscrid, gconfig.$vusubscrid)

                userservpack.value.subscribeuri = response.data.data.subscribeuri
                userservpack.value.packid = response.data.data.servpackid
                userservpack.value.packname = decodeURIComponent(response.data.data.servpack)
                userservpack.value.expiresed = response.data.data.expiresdate
                userservpack.value.expiresdays = response.data.data.expiresdays
                userservpack.value.resetdays = response.data.data.resetdays
                userservpack.value.flowused = response.data.data.flowused.toFixed(0x02)
                userservpack.value.flowtotal = response.data.data.flowtotal.toFixed(0x02)

                userflowpercent.value = (userservpack.value.flowused / userservpack.value.flowtotal)*100
                //console.log(userflowpercent.value)
            }
        }
        loading_subscribe.value = false
    }).catch((error)=>{
        gconfig.$axiosErrorHandle(error)
    })
})

const changeroute = (sign) => {
    if(ismobile.value){
        btmpanelheight.value = sign>0x00?`${(200+sign*50)}px`:'310px'
    }
}

onUnmounted(()=>{
    //console.log("dashboard unmounted")
})


</script>

<style src="./../assets/common.css" scoped></style>
<style scoped>
.announcearea{
    height: 248px;
    background: gray;
    /*
    background-image: url(./../assets/loginbg.jpg);
    */
    /* background-image: url(./../assets/loginbg.jpg); */
    background-size: 100% auto;
    background-position: 10% 70%;
}
.announceareamobile{
    height: 248px;
    background: gray;
    /* background-image: url(./../assets/loginbg2.jpg); */
    background-size: auto 150%;
    background-position: 50% 80%;
}
:deep(.slick-slide) {
    text-align: left;
    height: 248px;
    overflow: hidden;
    padding: 22px 20px;
}

.expiresinfo {
    color:#666666;
}
.progressline {
    line-height:5px;
    color:#666666;
}
.infoitem{
    display:block;
    margin:0;
    padding:20px;
    text-align: left;
}
.infoitem:hover{
    background-color: #f6f6f6;
}
.infocnt{
    margin:0;
    padding:0;
}
.infoicon {
    float:right;
    font-size:32px;
    color:#999999;
}
.infolinetit {
    font-size:16px;
    color:#333333;
}
.infolinedec {
    font-size:12px;
    color:#999999;
}
.qrcodearea {
    padding: 15px 0;
    text-align: center;
}
.qrcode {
    width:128px;
    height:128px;
    border:0;
    background-color:#f0f0f0;
}
.qrcodeintro{
    font-size:12px;
    text-align: center;
    color:#999999;
}
.empsubscr{
    display: block;
    text-align:center;
    color:#999999;
}
.empsubscr:hover{
    color:#666666;
}
.addsubscr{
    font-size:40px;
    font-weight: bolder;
}
.v2ray-bg-pixels{
    background-image: url(data:image/svg+xml;base64,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);
    background-size: auto;
    background-color:#7f7f7f;
}
.hayakudraw{
    background-color:#030303;
    background-image: url(../assets/hykdraw.png);
    background-size: auto 90%;
    background-repeat: no-repeat;
    background-position: center center;
}
</style>